<template>
  <div>
    <span
      class="photo-ske ske h-8 w-8 rounded-full text-white flex items-center justify-center "
      :class="iconClass"
    >
      <svg v-if="type === 'products' || type === 'websiteProducts'"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 48 48"
      >
        <g
          transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
        >
          <g>
            <path
              stroke-width="1.2"
              d="M1.5,8.5V13a.5.5,0,0,0,.5.5H12a.5.5,0,0,0,.5-.5V8.5"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
            <line
              stroke-width="1.2"
              x1="8"
              y1="8.5"
              x2="8"
              y2="13.5"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></line>
            <line
              stroke-width="1.2"
              x1="1.5"
              y1="10"
              x2="8"
              y2="10"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></line>
            <polygon
              stroke-width="1.2"
              points="0.5 4 2 0.5 12 0.5 13.5 4 0.5 4"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></polygon>
            <path
              stroke-width="1.2"
              d="M4.75,4V5a2,2,0,0,1-2,2H2.47a2,2,0,0,1-2-2V4"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
            <path
              stroke-width="1.2"
              d="M9.25,4V5a2,2,0,0,1-2,2h-.5a2,2,0,0,1-2-2V4"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
            <path
              stroke-width="1.2"
              d="M13.5,4V5a2,2,0,0,1-2,2h-.25a2,2,0,0,1-2-2V4"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
          </g>
        </g>
      </svg>
      <svg v-else-if="type === 'brands' || type === 'attributes'"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 48 48"
      >
        <g
          transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
        >
          <g>
            <path
              d="M13.25,9.36,9.36,13.25a.75.75,0,0,1-1.06,0L1.79,6.74a.36.36,0,0,1-.11-.29l.59-3.84a.37.37,0,0,1,.34-.34l3.84-.59a.36.36,0,0,1,.29.11L13.25,8.3A.75.75,0,0,1,13.25,9.36Z"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
            <line
              x1="4.03"
              y1="4.03"
              x2="0.53"
              y2="0.53"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></line>
          </g>
        </g>
      </svg>
      <svg v-else-if="type === 'editor-packages'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
        height="18"
        width="18"
      >
        <path
          d="M4.09,1.19a2,2,0,0,1,.6,1.33L6.52.7a.67.67,0,0,1,1,0L9,2.24a2.18,2.18,0,0,0-.57.4,2.06,2.06,0,0,0,2.91,2.91,2.18,2.18,0,0,0,.4-.57L13.3,6.52a.67.67,0,0,1,0,1L11.48,9.31a2.05,2.05,0,1,1-2.17,2.17L7.48,13.3a.67.67,0,0,1-1,0L5,11.76a2.18,2.18,0,0,0,.57-.4A2.06,2.06,0,0,0,2.64,8.45a2.18,2.18,0,0,0-.4.57L.7,7.48a.67.67,0,0,1,0-1L2.52,4.69a2,2,0,0,1-1.33-.6,2.05,2.05,0,0,1,2.9-2.9Z"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
      <svg v-else-if="type === 'synonyms'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="18" height="18">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802" />
      </svg>
      <svg v-else-if="type === 'categories'"
        width="18"
        height="18"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <g
          transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
        >
          <g>
            <path
              d="M13.28,9.39,9.39,13.28a.75.75,0,0,1-1.06,0L.61,5.56A.36.36,0,0,1,.5,5.27l.59-3.83a.37.37,0,0,1,.35-.35L5.27.5a.36.36,0,0,1,.29.11l7.72,7.72A.75.75,0,0,1,13.28,9.39Z"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
            <circle
              cx="4.11"
              cy="4.11"
              r="0.5"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></circle>
          </g>
        </g>
      </svg>
      <svg v-else-if="type === 'discounts'"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
          d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
      <svg v-else-if="type === 'suppliers'"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 48 48"
      >
        <g
          transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
        >
          <g>
            <path
              d="M.5,4.5h13a0,0,0,0,1,0,0V13a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,13V4.5A0,0,0,0,1,.5,4.5Z"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
            <path
              d="M.5,4.5h0a4,4,0,0,1,4-4h5a4,4,0,0,1,4,4h0"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
            <path
              d="M11,13.5V8a.5.5,0,0,0-.5-.5h-7A.5.5,0,0,0,3,8v5.5"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></path>
            <line
              x1="3"
              y1="9.5"
              x2="11"
              y2="9.5"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></line>
            <line
              x1="3"
              y1="11.5"
              x2="11"
              y2="11.5"
              style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
            ></line>
          </g>
        </g>
      </svg>
      <svg v-else-if="type === 'users'"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        />
      </svg>
      <svg v-else-if="type === 'websites'"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
          d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
        />
      </svg>
      <svg v-else-if="type === 'groups'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor" width="24" height="24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor" width="24" height="24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
      </svg>
    </span>
  </div>
</template>

<script>

/*

products
attributes
brands
editor-packages
categories
discounts
websiteProducts
suppliers
users
websites

websiteFiles
productFiles

* * */

export default {
  props: {
    type: String,
    event: String,
  },
  computed: {
    iconClass() {
      switch (this.event) {
        case "create": return "bg-green-400"
        case "update": return "bg-blue-400"
        case "delete": return "bg-red-400"
      }
    },
  },
}

</script>
